import React, {useEffect} from "react";
import ReportUtils from "../../../../../utils/report-utils.js";
import ReportChart from "../../../../../components/reports/charts/report-chart.jsx";
import OccurrenceMappingCards from "./components/occurrence-mapping-cards.jsx";
import OccByNeighborhoodAndPeriod from "./components/occ-by-neighborhood-and-period.jsx";
import OccurrenceMappingMap from "./components/occurrence-mapping-map.jsx";
import {createBarChart, createHorizontalBarChart} from "../../../../../components/reports/charts/utils.js";
import {
  createWeekAnalysisChart,
  exportCards,
  exportMainList,
  exportOccByNeighborhoodAndPeriodTable,
  reportsInfo
} from "./components/utils/occurrence-mapping-utils.js";

const DAY_OF_WEEK_LABELS = {
  0: "Domingo",
  1: "Segunda-feira",
  2: "Terça-feira",
  3: "Quarta-feira",
  4: "Quinta-feira",
  5: "Sexta-feira",
  6: "Sábado"
};

const HOUR_INTERVAL_LABELS = {
  1: "0 - 2",
  2: "2 - 4",
  3: "4 - 6",
  4: "6 - 8",
  5: "8 - 10",
  6: "10 - 12",
  7: "12 - 14",
  8: "14 - 16",
  9: "16 - 18",
  10: "18 - 20",
  11: "20 - 22",
  12: "22 - 24"
};

const ReportContent = ({data, collapsed}) => {
  const dateAnalysis = (data?.dateAnalysis ?? []).reduce((analysis, item) => {
    if (analysis[item.source]) analysis[item.source].push(item);
    return analysis;
  }, {week: [], day_week: [], hour: []});

  useEffect(() => {
    if (!data) return;

    exportMainList(data.occMappingList ?? []);

    exportCards(data.occCards);

    createHorizontalBarChart({
      data: data.occStatus ?? [],
      reportInfo: reportsInfo.occStatus,
      labelKey: "status"
    });

    createHorizontalBarChart({
      data: data.occPeriodDistribution ?? [],
      reportInfo: reportsInfo.occPeriodDistribution,
      labelKey: "period"
    });

    exportOccByNeighborhoodAndPeriodTable(data.occByNeighborhoodAndPeriod ?? []);
    createWeekAnalysisChart(dateAnalysis.week, reportsInfo.weekAnalysis);

    createBarChart({
      data: dateAnalysis.day_week.map(item => ({label: DAY_OF_WEEK_LABELS[item.week], qty: item.qty})),
      reportInfo: reportsInfo.dayWeekAnalysis,
      labelFieldName: "label",
      customLabel: ["Dia da semana", "Quantidade"]
    });

    createBarChart({
      data: dateAnalysis.hour.map(item => ({label: HOUR_INTERVAL_LABELS[item.week], qty: item.qty})),
      reportInfo: reportsInfo.hourAnalysis,
      labelFieldName: "label",
      customLabel: ["Intervalo de horas", "Quantidade"],
      reportName: "Por intervalo de horas"
    });

    createBarChart({
      data: data.alarmsByCapturePlace?.map(item => ({label: ReportUtils.formatText(item.description), qty: item.qty})),
      reportInfo: reportsInfo.alarmsByCapturePlace,
      labelFieldName: "label",
      limit: 10,
      rotated: true,
      reportName: "Alarmes por ponto de coleta"
    });

  }, [data, collapsed]);

  return (
    <>
      <OccurrenceMappingCards key={`cards-${collapsed}`} data={data?.occCards}/>
      <ReportChart key={`status-${collapsed}`} reportInfo={reportsInfo.occStatus} type="horizontal"/>
      <ReportChart key={`period-${collapsed}`} reportInfo={reportsInfo.occPeriodDistribution} type="horizontal"/>
      <OccurrenceMappingMap data={data?.mapInfo}/>
      <OccByNeighborhoodAndPeriod key={`neighborhood-${collapsed}`} data={data?.occByNeighborhoodAndPeriod ?? []} reportInfo={reportsInfo.occByNeighborhoodAndPeriod}/>
      <ReportChart key={`week-${collapsed}`} reportInfo={reportsInfo.weekAnalysis} limit={10} dataLength={dateAnalysis.week.length}/>
      <ReportChart key={`day-week-${collapsed}`} reportInfo={reportsInfo.dayWeekAnalysis}/>
      <ReportChart key={`hour-${collapsed}`} reportInfo={reportsInfo.hourAnalysis}/>
      <ReportChart key={`alarms-${collapsed}`} reportInfo={reportsInfo.alarmsByCapturePlace} limit={10} dataLength={data?.alarmsByCapturePlace?.length}/>
      <div id="chart-tables"/>
    </>
  );
};

export default ReportContent;
